import { render, staticRenderFns } from "./ModalPause.vue?vue&type=template&id=5625156e"
import script from "./ModalPause.vue?vue&type=script&lang=js"
export * from "./ModalPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports